var map = {
	"./2@2x.png": "b165",
	"./CombinedShape0419.png": "c23d",
	"./CombinedShape04191.png": "b79f",
	"./about/I58A5054@2x.png": "538c",
	"./about/shutterstock_53252755@2x.png": "44f1",
	"./add-product.png": "a861",
	"./addGoods.png": "8c9f",
	"./added.png": "db9d",
	"./adding.png": "34b1",
	"./address-bg.png": "89e9",
	"./address.png": "681b",
	"./back-chevron-copy2.png": "0a60",
	"./bg/alltype.png": "7b73",
	"./bg/herb-1.png": "154e",
	"./bg/herb-2.png": "f74b",
	"./bg/mineral-1.png": "f5f4",
	"./bg/mineral-2.png": "1c63",
	"./bg/moretype.png": "48d0",
	"./bg/probiotic-1.png": "109c",
	"./bg/probiotic-2.png": "7d56",
	"./bg/special-1.png": "a590",
	"./bg/special-2.png": "9d47",
	"./bg/special-3.png": "bd5c",
	"./bg/vitamin-1.png": "f784",
	"./bg/vitamin-2.png": "16b1",
	"./bg/vitamin-3.png": "1bdd",
	"./button@2x.png": "7032",
	"./card-background.png": "74f2",
	"./cart-menu-cart.png": "5d07",
	"./cart-menu-repot.png": "4ddb",
	"./check-report-button.png": "daf0",
	"./colseimg.png": "4e47",
	"./del-group.png": "c4cc",
	"./delete2.png": "aa36",
	"./faxian.png": "3ac6",
	"./fenxiangcopy.png": "5953",
	"./filecheck.png": "11dd",
	"./filechecked.png": "3802",
	"./gou.png": "a905",
	"./home-shortcut-address.png": "ee28",
	"./home-shortcut-coupon.png": "6270",
	"./home-shortcut-order.png": "7d44",
	"./home-shortcut-vip.png": "11ca",
	"./icon-account-sr.png": "b700",
	"./icon-account-zc.png": "79e9",
	"./icon-all.png": "14d7",
	"./icon-cart-add-disabled.png": "5abc",
	"./icon-cart-add.png": "22f0",
	"./icon-cart-minus-disabled.png": "3ffe",
	"./icon-cart-minus.png": "5445",
	"./icon-check.png": "55a7",
	"./icon-checked.png": "582f",
	"./icon-checked2.png": "ce65",
	"./icon-close.png": "9304",
	"./icon-close2.png": "8697",
	"./icon-coupon.png": "aca0",
	"./icon-delete.png": "f516",
	"./icon-delete3.png": "473b",
	"./icon-dengpao.png": "bb77",
	"./icon-edit.png": "3f76",
	"./icon-extend.png": "a742",
	"./icon-location.png": "4915",
	"./icon-logistics-disabled.png": "dd53",
	"./icon-logistics.png": "a599",
	"./icon-money.png": "e8e1",
	"./icon-msg.png": "a90c",
	"./icon-next.png": "fb54",
	"./icon-next2.png": "7672",
	"./icon-next3.png": "cd51",
	"./icon-next4.png": "b12b",
	"./icon-next5.png": "e79b",
	"./icon-order-status1.png": "a6b7",
	"./icon-payment.png": "1f81",
	"./icon-prev.png": "b932",
	"./icon-right.png": "c9f6",
	"./icon-up.png": "54e6f",
	"./icon-wechat.png": "11b2",
	"./icon-yao.png": "b690",
	"./index/I58A5028@2x.png": "94c1",
	"./index/I58A5040@2x.png": "876c",
	"./index/Rectangle@2x.png": "eca3",
	"./index/ginger@2x.png": "1171",
	"./index/grape@2x.png": "d512",
	"./index/indextop.png": "5934",
	"./jia.png": "e5a7",
	"./jian.png": "bc8d",
	"./jian2.png": "2d40",
	"./logo.png": "cf05",
	"./logo1.png": "534f",
	"./logo2.png": "5fbe",
	"./logo3.png": "d092",
	"./luntan.png": "685b",
	"./mealCart.png": "9134",
	"./order-status-bg.png": "7a18",
	"./paychecked.png": "91db",
	"./placeholder-happy.png": "9c06",
	"./placeholder-hehe.png": "4615",
	"./placeholder-shutup.png": "05ad",
	"./qr.png": "507e",
	"./qrcode_for_gh_fcfc67db8562_860@2x.png": "eee3",
	"./question-base-active.png": "7640",
	"./question-base.png": "2a6b",
	"./question-qita-active.png": "d2a7",
	"./question-qita.png": "945f",
	"./question-shms-active.png": "f091",
	"./question-shms.png": "999a",
	"./question-xuqiu-active.png": "24fc",
	"./question-xuqiu.png": "dc1c",
	"./report-border.png": "7361",
	"./report-tip1.png": "c2a3",
	"./report-tip2.png": "8d97",
	"./sanjiao.png": "0a48",
	"./share-card.png": "34f7",
	"./tab-bar/indexcart.png": "746d",
	"./tab-bar/indexme.png": "8bd3",
	"./tab-bar/nav-cart-disable@2x.png": "e17f",
	"./tab-bar/nav-cart@2x.png": "152d",
	"./tab-bar/nav-home-disable@2x.png": "d9c3",
	"./tab-bar/nav-home@2x.png": "087f",
	"./tab-bar/nav-me-disable@2x.png": "0331",
	"./tab-bar/nav-me@2x.png": "bc39",
	"./tab-bar/nav-product-disable@2x.png": "d2b9",
	"./tab-bar/nav-product@2x.png": "af6d",
	"./tab-bar/nav-report-disable@2x.png": "c301",
	"./tab-bar/nav-report@2x.png": "d812",
	"./talksanjiao.png": "dacf",
	"./teachercopy.png": "e71d",
	"./wechat.png": "ead3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";